var _g, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWarehouse = function SvgWarehouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 20,
    height: 20.2104,
    rx: 4.375,
    fill: "#222222"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 20.2109H19H25.875C25.875 20.2109 21.1977 20.8743 20.25 22.1057C20.1336 22.2568 19.9473 22.5315 19.7537 22.8257C19.3988 23.3649 18.6012 23.3649 18.2463 22.8257C18.0527 22.5315 17.8664 22.2568 17.75 22.1057C16.8023 20.8743 12.125 20.2109 12.125 20.2109Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8016 4.67839L19.7404 13.6209C19.4876 13.6691 19.2512 13.7811 19.0588 13.9422L12.6316 11.7421L12.1963 13.0139L18.548 15.1881C18.6076 15.7593 19.0075 16.28 19.6097 16.4861C20.4235 16.7646 21.2974 16.3624 21.5628 15.587C21.7624 15.0042 21.5609 14.3786 21.1049 13.9853L23.6992 6.40655L25.3683 6.97791L25.8036 5.70607L22.8016 4.67839ZM20.5904 15.2544C20.5003 15.5177 20.2032 15.6544 19.9268 15.5598C19.6505 15.4653 19.4995 15.175 19.5897 14.9118C19.6798 14.6485 19.9769 14.5118 20.2532 14.6064C20.5296 14.701 20.6804 14.991 20.5904 15.2544Z",
    fill: "#01cdfb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3999 7.72095L16.1501 6.95074L14.4679 11.8646L16.7176 12.6348L18.3999 7.72095Z",
    fill: "#01cdfb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.089 13.4508L20.7712 8.537L18.5215 7.76679L16.8392 12.6806L19.089 13.4508Z",
    fill: "#01cdfb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8726 5.16967L18.561 4.03607L17.481 7.19127L20.7926 8.32487L21.8726 5.16967ZM20.7454 5.10615L21.672 5.42327L21.3549 6.34983L20.4283 6.03271L20.7454 5.10615Z",
    fill: "#01cdfb"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 30,
    r: 4,
    fill: "#222222"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 30,
    r: 2,
    fill: "#01cdfb"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.25,
    y: 0,
    width: 37.5,
    height: 37.7104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.375
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarehouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Warehouse.f88c6aa3.svg";
export { ForwardRef as ReactComponent };